/** @format */

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAlarming: '/monitor/?Action=DescribeAlertingResources&Version=2021-01-01' // 获取实例列表
}
